
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  authorizationHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  locale: string,
  token: string
};

/**
 * Export `fetchUserFavoritesPdf`.
 */

export async function fetchUserFavoritesPdf({ locale, token }: Query) {
  const endpoint = getApiEndpoint('getUserFavoritesPdf');

  if (!token) {
    return;
  }

  try {
    return await request.get(endpoint, {
      headers: {
        ...acceptLanguageHeader(locale),
        ...authorizationHeader(token)
      },
      responseType: 'blob'
    });
  } catch (error) {
    handleRequestError(error);
  }
}
